//angular
import { Component, EventEmitter, Output, OnDestroy, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { AppAnimations } from 'src/app/_shared/animations';
import { DataSharingService } from 'src/app/_core/services';
import { DropDown } from 'src/app/_shared/interfaces/dropdown.interface';
import { VisibleState, collectionOfChargeModel, collectionOfProductSetupPrice } from 'src/app/app.data';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

export interface PriceBulk {
    amount: number;
    price: number;
    qtyMin: number;
    qtyMax: number;
    type: string;
}

export interface ProductPrice {
    currencyId: number;
    price: number;
    productPriceBulk: Array<PriceBulk>
}

@Component({
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', '[@slideInRightAnimation]': '' },
  selector: 'product-price',
  templateUrl: './product-price.component.html'
})

export class PanelProductPriceComponent implements OnInit, OnDestroy {
  collectionOfPriceModel: Array<DropDown> = collectionOfChargeModel;
  collectionOfProductCurrency: Array<any> = [];
  collectionOfProductSetupFee: Array<DropDown> = collectionOfProductSetupPrice;
  form: FormGroup;
  formProductCurrency: FormGroup;
  statusPriceModelOpt1: Array<VisibleState> = [];
  statusPriceModelOpt2: Array<VisibleState> = [];
  statusPriceModelOpt3: Array<VisibleState> = [];
  statusPriceModelOpt4: Array<VisibleState> = [];
  private subs = new Unsubscriber();

  @Input()
  collectionOfCompanyCurrency: Array<any>;

  @Output()
  onRemovePriceOption: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _fb: FormBuilder,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _shareData: DataSharingService
  ) {
    this._iconRegistry.addSvgIcon('ico-info', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-help-faq.svg'));

    this.subs.addSub = this._shareData.currentForm.subscribe((data) => {
      if (Object.keys(data).length !== 0) {
        this.form = <FormGroup>data;
        this.formProductCurrency = <FormGroup>this.form.controls.productCurrency;
        if ( Object.keys(<FormArray>this.form.controls.productCurrency).length !== 0) {
          const productCurrency = <FormArray>(this.form.controls.productCurrency.value);
          if (Number(<Array<any>>productCurrency['currencies'].length) > Number(this.collectionOfProductCurrency.length)) {
            this.collectionOfProductCurrency = <Array<any>>(productCurrency['currencies']);
            const lastIndex = Number(<Array<any>>productCurrency['currencies'].length) - 1;
            this.statusPriceModelOpt1[lastIndex] = VisibleState.isVisible;
            this.statusPriceModelOpt2[lastIndex] = VisibleState.isHidden;
            this.statusPriceModelOpt3[lastIndex] = VisibleState.isHidden;
            this.statusPriceModelOpt4[lastIndex] = VisibleState.isHidden;
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this._shareData.setForm({});
    this.subs.unsubscribe();
  }

  ngOnInit() {}

  onChangePriceModel(_value: number, _index: number) {
    this.statusPriceModelOpt1[_index] = _value == 1 ? VisibleState.isVisible : VisibleState.isHidden;
    this.statusPriceModelOpt2[_index] = _value > 1 ? VisibleState.isVisible : VisibleState.isHidden;

    if (_value == 1) {
      this.form.controls.productCurrency['controls'].currencies['controls'][_index].controls['productPriceBulk'].controls['collectionOfTier']
        .removeAt(this.form.controls.productCurrency['controls'].currencies['controls'][_index].controls['productPriceBulk'].controls['collectionOfTier'].length - 1);
    } else {
      this.form.controls.productCurrency['controls'].currencies['controls'][
        _index
      ].controls['productPriceBulk'].controls['collectionOfTier'].push(
        this.setProductBulkPrice()
      );
    }
  }

  onChangeSetupFeeOption(_value: any, _index: number) {
    if (_value === '1') {
      this.form.controls.productCurrency['controls'].currencies['controls'][
        _index
      ].controls['setupFeeAmount'].clearValidators();
      this.form.controls.productCurrency['controls'].currencies['controls'][
        _index
      ].controls['setupFeeAmount'].updateValueAndValidity();
      this.form.controls.productCurrency['controls'].currencies['controls'][
        _index
      ].controls['setupFeeAmount'].disable();
      this.form.controls.productCurrency['controls'].currencies['controls'][
        _index
      ].controls['setupFeeAmount'].setValue('');
    } else {
      this.form.controls.productCurrency['controls'].currencies['controls'][
        _index
      ].controls['setupFeeAmount'].setValidators([Validators.required]);
      this.form.controls.productCurrency['controls'].currencies['controls'][
        _index
      ].controls['setupFeeAmount'].updateValueAndValidity();
      this.form.controls.productCurrency['controls'].currencies['controls'][
        _index
      ].controls['setupFeeAmount'].enable();
    }

    console.log(
      this.form.controls.productCurrency['controls'].currencies['controls'][
        _index
      ]?.controls['setupFeeOption']
    );
    console.log(
      this.form.controls.productCurrency['controls'].currencies['controls'][
        _index
      ].controls['setupFeeAmount']
    );
  }

  removeProductPrice(_index: number) {
    this.collectionOfProductCurrency.splice(_index, 1);
    this.onRemovePriceOption.emit(_index);
  }

  setProductBulkPrice(): FormGroup {
    return this._fb.group({
      price: new FormControl(''),
      qtyMin: new FormControl(''),
      qtyMax: new FormControl(''),
      type: new FormControl(''),
      amount: new FormControl(''),
    });
  }
}
